import React, { useCallback, useContext, useEffect, useMemo } from "react";
import { StyleSheet, View } from "react-native";
import { useI18n } from "../../hooks/i18n-hooks";
import { useTheme } from "../../hooks/use-theme";
import VStack from "../../ui_atoms/VStack";
import Text from "../../components/Text";
import PostOnboardingImage from "../../assets/images/post-onboarding-image.svg";
import { AuthManagerContext } from "../../contexts/AuthManager";
import ScreenCard from "../ScreenCard";
import { StackScreenProps } from "@react-navigation/stack";
import { RootStackParamList } from "../../navigations/RootNavigation";
import { useNavigation } from "@react-navigation/native";
import { useChangeStatusBarColor } from "../../hooks/use-change-status-bar-color";
import { useTracking } from "../../hooks/tracking";

type ScreenParams = StackScreenProps<RootStackParamList>;

const PostOnboardingPrepare = () => {
    const i18n = useI18n();
    const { colors, gridSize } = useTheme();
    const styles = useStyles();
    const navigator = useNavigation<ScreenParams["navigation"]>();
    const { user } = useContext(AuthManagerContext);
    const { trackEvent } = useTracking();
    const next = useCallback(() => {
        navigator.navigate("PostOnboardingProfileEditor");
    }, [navigator]);

    useChangeStatusBarColor(colors.onPrimary);
    useEffect(() => {
        void trackEvent("signup_completed_worker");
    }, [trackEvent]);

    return (
        <ScreenCard
            style={{ backgroundColor: colors.onPrimary }}
            isContentContainerFlex
            buttons={[
                {
                    title: i18n.t(`screens.auth.postOnboarding.nextButton`),
                    onPress: next,
                },
            ]}
        >
            <VStack gap={1} h="2/3">
                <Text style={styles.title}>
                    {i18n.t(`screens.auth.postOnboarding.title`, {
                        name: user?.firstName,
                    })}
                </Text>
                <Text style={styles.subTitle}>
                    {i18n.t(`screens.auth.postOnboarding.sub_title`)}
                </Text>
                <View style={{ marginHorizontal: -gridSize }}>
                    <PostOnboardingImage width="100%" style={{ overflow: "visible" }} />
                </View>
                <Text style={styles.description}>
                    {i18n.t(`screens.auth.postOnboarding.description`)}
                </Text>
            </VStack>
        </ScreenCard>
    );
};

const useStyles = () => {
    const { fonts } = useTheme();

    return useMemo(
        () =>
            StyleSheet.create({
                title: {
                    ...fonts.titleLarge,
                    textAlign: "center",
                },
                subTitle: {
                    ...fonts.titleMedium,
                    textAlign: "center",
                },
                description: {
                    ...fonts.bodyMedium,
                    textAlign: "center",
                },
            }),
        [fonts.bodyMedium, fonts.titleLarge, fonts.titleMedium],
    );
};

export default PostOnboardingPrepare;
